/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

/* eslint no-undef: 0 */

import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api";

// Separate client for the unauthenticated guest endpoints. The shared `api`
// instance sends the admin's auth token and cookies and logs the session out on
// a 401 — neither belongs on a page a guest reaches from an email link, where
// the emailed token is the only credential.
const publicApi = axios.create({
  baseURL: API_BASE_URL,
});

export default publicApi;
